package org.mkui.component.absolute

import com.macrofocus.common.properties.SimpleArrayProperty
import js.coroutines.awaitCancellation
import js.objects.unsafeJso
import org.mkui.canvas.MouseListener
import org.mkui.canvas.MouseMotionListener
import org.mkui.canvas.ResizeObserver
import org.mkui.component.CPComponent
import org.mkui.component.CPInteractiveComponent
import org.mkui.component.CPInteractiveHandler
import org.mkui.component.InteractiveComponentListeners
import org.mkui.geom.Rectangle2D
import org.mkui.react.useProperty
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.useEffect
import react.useRef
import web.cssom.ObjectFit
import web.cssom.Position
import web.cssom.pct
import web.cssom.px
import web.html.HTMLDivElement

actual class AbsoluteCPContainer actual constructor(private val layout: Layout) : CPInteractiveComponent {
    protected val children: SimpleArrayProperty<CPComponent> = SimpleArrayProperty(emptyArray())
    protected val bounds: SimpleArrayProperty<Rectangle2D> = SimpleArrayProperty(emptyArray())

    private lateinit var resizeObserver: ResizeObserver
    private val divRef = useRef<HTMLDivElement>()
    val handler = InteractiveComponentListeners()

    var _width = 0.0
    var _height = 0.0

    override val nativeComponent : FC<*> = FC<Props> {
        val (getChildren, _) = useProperty(children)
        val (getBounds, _) = useProperty(bounds)

        useEffect {
            val targetContainer = divRef.current!!
            resizeObserver = ResizeObserver { _, _ -> publishData(targetContainer) }
            resizeObserver.observe(targetContainer)

            CPInteractiveHandler(targetContainer, handler)

            awaitCancellation {
                resizeObserver.disconnect()
            }
        }

        ReactHTML.div {
            style = unsafeJso {
                position = Position.absolute
//                width = 100.pct
//                height = 100.pct
                top = 0.px
                bottom = 0.px
                left = 0.px
                right = 0.px

                maxWidth = 100.pct
                maxHeight = 100.pct
                objectFit = ObjectFit.contain
            }

            ref = divRef

            for ((index, c) in getChildren.withIndex()) {

                val bounds = getBounds[index]
                println("Bounds: $bounds")

                ReactHTML.div {
                    style = unsafeJso {
                        position = Position.absolute
                        left = bounds.x.px
                        top = bounds.y.px
                        width = bounds.width.px
                        height = bounds.height.px
                    }

                    onMouseMove = {

                    }

                    c.nativeComponent()
                }
            }
        }
    }

    private fun publishData(canvas: HTMLDivElement) {
        val clientRect = canvas.getBoundingClientRect()
        println("AbsoluteCPContainer client: ${canvas.clientWidth}x${canvas.clientHeight}, offset: ${canvas.offsetWidth}x${canvas.offsetHeight}, bounding: ${clientRect.width}x${clientRect.height}")
        val width = canvas.clientWidth.toDouble()
        val height = canvas.clientHeight.toDouble()
        if(_width != width || _height != height) {
            _width = width // Todo: offsetWidth
            _height = height  // Todo: offsetHeight
            layout.layout(this, _width, _height)
        }
    }

    actual fun addComponent(component: CPComponent) {
        if(!children.contains(component)) {
            children.append(component)
            bounds.append(Rectangle2D.Double(0.0, 0.0, 0.0, 0.0))
            layout.layout(this, _width, _height)
        }
    }

    actual fun addComponent(component: CPComponent, layer: Int) {
        if(!children.contains(component)) {
            children.append(component)
            bounds.append(Rectangle2D.Double(0.0, 0.0, 0.0, 0.0))
            layout.layout(this, _width, _height)
        }
    }

    actual fun getBounds(child: CPComponent): Rectangle2D? {
        return this.bounds[children.indexOf(child)]
    }

    actual fun setBounds(component: CPComponent, bounds: Rectangle2D) {
        this.bounds[children.indexOf(component)] = bounds
    }

    actual fun setVisible(component: CPComponent, visible: Boolean) {
    }

    actual val width: Double
        get() = _width
    actual val height: Double
        get() = _height

    actual override fun addMouseListener(l: MouseListener) {
        handler.addMouseListener(l)
    }

    actual override fun addMouseMotionListener(l: MouseMotionListener) {
        handler.addMouseMotionListener(l)
    }

    actual override fun removeMouseListener(l: MouseListener) {
        handler.removeMouseListener(l)
    }

    actual override fun removeMouseMotionListener(l: MouseMotionListener) {
        handler.removeMouseMotionListener(l)
    }
}